export const RETURN_OUTCOME_REQUIRED_MESSAGE = 'Choose Restock, Quarantine or Destroy.';
//# sourceMappingURL=return-outcome-required-message.js.map